import { ForwardedRef, ReactNode, forwardRef, useImperativeHandle } from 'react';
import ZoomableContext from '../../context/ZoomableContext';
import { IZoomableRef, UseZoomableProps } from '../../helpers/zoomable.types';
import useZoomable from '../../hooks/useZoomable';
import ZoomableContainer from '../ZoomableContainer/ZoomableContainer';
import ZoomableContent from '../ZoomableContent/ZoomableContent';
import ZoomableControls from '../ZoomableControls/ZoomableControls';

// interface ZoomableComposition {
//     Container?: typeof ZoomableContainer;
//     Content?: typeof ZoomableContent;
//     Controls?: typeof ZoomableControls;
// }

interface ZoomableProps extends UseZoomableProps {
    children?: ReactNode;
    ref?: ForwardedRef<IZoomableRef>;
}

const Zoomable = forwardRef<IZoomableRef, ZoomableProps>((props, ref) => {
    const { children, ...rest } = props;

    const { refs, state, zoomIn, zoomOut, zoomTo, zoomToContent, setTransform } = useZoomable(rest);

    useImperativeHandle(ref, () => {
        return {
            state,
            zoomIn,
            zoomOut,
            zoomTo,
            zoomToContent,
            setTransform,
        };
    });

    return (
        <ZoomableContext.Provider
            value={{
                refs,
                state,
                zoomIn,
                zoomOut,
                zoomTo,
                zoomToContent,
                setTransform,
            }}
        >
            {children}
        </ZoomableContext.Provider>
    );
}) as any;

Zoomable.Container = ZoomableContainer;
Zoomable.Content = ZoomableContent;
Zoomable.Controls = ZoomableControls;

export default Zoomable;
